import React, { memo, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import AnalyticsImage from "../../../images/analytics.png"
import Connect from "../../../images/synch1.png"
import { CarouselAnalytic } from '../../../components/modals/CarouselAnalytic'
import { fetchWebsites, selectAll } from '../../../features/websites/websitesSlice'
import { selectUserInfo } from '../../../features/users/userInfoSlice'
import { selectorTour } from '../../../features/tour/tourSlice'
import WebsiteTab from '../../../components/WebsiteTab'

/**
 * CONNECTION BUBBLE COMPONENT
 * @param {{title: string, children: JSX.Element, disabled: boolean, connect: () => void}} props 
 * @returns {JSX.Element}
 */
const ConnectionBubble = ({ title, children, disabled, connect }) => {
	return (
		<button
			disabled={disabled}
			onClick={connect}
			className={"w-28 text-center border-2 border-gray-100 rounded-3xl text-xs aspect-square justify-center items-center flex disabled:cursor-not-allowed disabled:bg-gray-100 bg-white hover:border-gray-200 transition-colors"}>
			{title}
			{children}
		</button>
	)
}

const MesConnextions = () => {
	const dispatch = useDispatch();

	/**
	 * @type {Website[]}
	 */
	const websites = useSelector(selectAll)

	const userInfoContext = useSelector(selectUserInfo)

	const isTourLaunched = useSelector(selectorTour)

	const [modalOpen, setModalOpen] = useState(false)

	useEffect(() => {
		if (websites.length > 0) return
		dispatch(fetchWebsites({ company_id: userInfoContext?.user?.company_id }))
	}, [userInfoContext?.user?.company_id])


	const connect = useCallback(() => {
		setModalOpen(true)
	}, [])

	return (
		<div className="mx-auto max-w-4xl my-10">
			<div className="mx-auto max-w-lg mb-8">
				<WebsiteTab />
			</div>

			<div className="bg-white shadow rounded-3xl space-y-6 p-10 w-full step4 relative">
				<button
					onClick={() => window.open('https://calendly.com/azatys/onboarding', '_blank')}
					type='button'
					className="absolute right-3 top-3 rounded-full py-1 px-5 text-xs uppercase tracking-wide font-medium text-white bg-teal-700 hover:bg-teal-800 transition-colors hover:border-none disabled:text-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed w-[350px]"
				>
					Prendre RDV pour la mise en place de vos tableaux personnalisés
				</button>
				<div className="mx-auto text-center space-y-4">
					<img src={Connect} className="h-20 mx-auto" alt="" />
					<p className="text-gray-500 text-sm">
						Merci de connecter vos plateformes existantes
					</p>
				</div>
				<div className="uppercase mx-auto text-gray-400 font-medium flex gap-2 items-center justify-between">
					<div>Analytics</div>
					<div className="flex gap-2 items-center col-span-2">
						<ConnectionBubble title="" disabled={isTourLaunched} connect={connect}>
							<img className="h-12" src={AnalyticsImage} />
						</ConnectionBubble>
						<ConnectionBubble title="Coming soon" disabled={true} />
						<ConnectionBubble title="Coming soon" disabled={true} />
					</div>
				</div>
				<div className="uppercase mx-auto text-gray-400 font-medium flex gap-2 items-center justify-between">
					<div>Reseaux sociaux</div>
					<div className="flex gap-2 items-center col-span-2">
						<ConnectionBubble title="Coming soon" disabled={true} />
						<ConnectionBubble title="Coming soon" disabled={true} />
						<ConnectionBubble title="Coming soon" disabled={true} />
					</div>
				</div>
				<div className="uppercase mx-auto text-gray-400 font-medium flex gap-2 items-center justify-between">
					<div>Emailing</div>
					<div className="flex gap-2 items-center col-span-2">
						<ConnectionBubble title="Coming soon" disabled={true} />
					</div>
				</div>
				<div className="uppercase mx-auto text-gray-400 font-medium flex gap-2 items-center justify-between">
					<div>E-Commerce</div>
					<div className="flex gap-2 items-center justify-start">
						<ConnectionBubble title="WooComerce" disabled={true} />
						<ConnectionBubble title="Coming soon" disabled={true} />
					</div>
				</div>
			</div>
			<CarouselAnalytic setOpen={setModalOpen} open={modalOpen} />
		</div>
	)
}

export default memo(MesConnextions)